export default "__VITE_ASSET__aDevolvW__"